<template>
  <div class="home">
    <div class="content">
      <p class="title">{{title}}</p>
      <div class="information clear">
        <div class="tag-wrap clear">
          <span class="tag" v-for="(tag, index) in tag(tags)" :key="index">{{tag}}</span>
        </div>
        <div class="views">{{pv}}次浏览</div>
      </div>
      <Article v-if="type === 1" :content="content"></Article>
      <Video v-if="type === 2" :vid="vid"></Video>
      <div class="date">{{pDate}}</div>
    </div>
    <div v-if="showComment">
      <comment-main></comment-main>
      <comment-add-button>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconpinglun1"></use>
        </svg>
      </comment-add-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import api from '@/api'
import { isWx } from '@/utils/envDetect'
import Video from '../Video/Video.vue'
import Article from '../Article/Article.vue'

export default {
  name: 'detail',
  components: {
    Video,
    Article,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: 0,
      title: '',
      content: '',
      tags: [],
      pDate: '',
      pv: 0,
      cImg: '',
      showComment: isWx(),
    }
  },
  mounted() {
    this.getPv()
    api
      .news(this.id, {
        s: new Date().getTime(),
      })
      .then((res) => {
        const {
          type, title, content, tags, vid, p_date: pDate, cover_url: cUrl,
        } = res
        this.type = type
        this.title = title
        if (this.type === 1) {
          this.content = content
        } else {
          this.vid = vid
          this.cImg = cUrl
        }
        this.tags = tags
        this.pDate = pDate
        this.view()
        this.initComment()
        this.wxConfig()
      })
  },
  methods: {
    initComment() {
      const date = this.pDate ? this.pDate.split('-', 2).join('') : 201906
      const that = this
      this.$comment.refresh({
        options: {
          stime: date, // 当前资源的创建时间，年月即可
          objid: `${that.id}${process.env.NODE_ENV}`, // 当前资源的自定义 id，需保证唯一性
        },
      })
    },
    tag(tags) {
      return tags.slice(0, 2)
    },
    getPv() {
      api.getPv(this.id).then((res) => {
        this.pv = res.pv
      })
    },
    view() {
      api.pv({
        id: this.id,
        type: this.type,
      })
    },
    wxConfig() {
      // 微信分享配置
      const share = {
        img: this.cImg || null,
        title: this.title,
        desc: '最全攻略一网打尽，点击查看',
        href: window.location.href,
      }
      this.$wxShare(share)
    },
  },
}
</script>

<style scoped lang="scss" src="./detail.scss"></style>
<style lang="scss">
.comment-add-bar {
  display: none;
}
.comment--highlight {
  color: #ea7133;
}
.comment-add-button {
  color: transparent;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  position: fixed;
  right: 15px;
  bottom: 15px;
  background: #ea7133;
  .icon {
    color: #fff;
    font-size: 20px;
  }
}
</style>

